// 설정 모듈 번역 - 한국어
export default {
  title: '설정',
  subtitle: '앱 경험을 개인화하세요',
  
  // 설정 그룹
  groups: {
    privacySecurity: '개인정보 보호 및 보안',
    appSettings: '앱 설정',
    personalData: '개인 데이터',
    helpSupport: '도움말 및 지원'
  },
  
  // 설정 항목
  items: {
    privacySettings: {
      title: '개인정보 설정 및 정책',
      subtitle: 'AI 기능, 데이터 사용 제어'
    },
    privacyCollection: {
      title: '개인정보 수집',
      subtitle: '데이터 사용 방법 확인'
    },
    appSettings: {
      title: '앱 설정',
      subtitle: '앱 동작 사용자 정의'
    },
    notificationSettings: {
      title: '알림 설정',
      subtitle: '푸시 알림 기본 설정 관리'
    },
    languageSettings: {
      title: '언어 설정',
      subtitle: '선호하는 언어를 선택하세요',
      sectionTitle: '언어 선택',
      sectionSubtitle: '선호하는 언어를 선택하세요',
      note: '언어 변경은 즉시 적용되며 앱을 다시 시작할 필요가 없습니다'
    },
    bodyDataSetup: {
      title: '신체 데이터 설정',
      subtitle: '건강 데이터 매개변수 구성'
    },
    helpFeedback: {
      title: '도움말 및 피드백',
      subtitle: '도움을 받거나 제안 제공',
      appTitle: 'CubeMeet',
      appSlogan: '함께 큐브, 더 나은 만남을',
      appDescription: '다양한 공동 구매 활동과 지능형 기능을 지원하는 종합 소셜 플랫폼입니다.',
      coreFeatures: '핵심 기능',
      contactSupport: '지원팀 연락',
      emailFeedback: '이메일 피드백',
      emailFeedbackDesc: '이메일 보내기',
      features: {
        travel: {
          name: '여행',
          desc: '스마트 여행 경비 분담, AI 영수증 인식'
        },
        carpool: {
          name: '카풀',
          desc: '친환경 이동, 에코 라이드셰어'
        },
        dining: {
          name: '식사',
          desc: '이벤트 모임 및 식사'
        },
        shopping: {
          name: '쇼핑',
          desc: '중고 거래, 지역 마켓플레이스'
        },
        fitness: {
          name: '피트니스',
          desc: '체중 관리, 건강 추적'
        },
        todo: {
          name: 'Todo',
          desc: '작업 관리, 협업 목록'
        },
        ledger: {
          name: '가계부',
          desc: '개인 및 클라우드 회계'
        },
        groupBuying: {
          name: '그룹 구매',
          desc: '그룹 주문, 음식 배달 공유'
        },
        toolbox: {
          name: '도구상자',
          desc: 'AI 스마트 도구, 지능형 레시피'
        }
      }
    },
    dataExport: {
      title: '데이터 내보내기',
      subtitle: '개인 데이터 다운로드'
    },
    deleteAccount: {
      title: '계정 삭제',
      subtitle: '계정과 데이터를 완전히 삭제'
    }
  },
  
  // 알림
  notifications: {
    languageChanged: '언어가 성공적으로 변경되었습니다',
    settingsSaved: '설정이 저장되었습니다',
    dataExported: '데이터가 성공적으로 내보내졌습니다',
    accountDeleted: '계정이 삭제되었습니다'
  },
  
  // 확인 대화상자
  confirmations: {
    deleteAccount: {
      title: '계정 삭제',
      message: '이 작업은 되돌릴 수 없습니다. 정말로 계정을 삭제하시겠습니까?',
      confirm: '삭제',
      cancel: '취소'
    },
    dataExport: {
      title: '데이터 내보내기',
      message: '개인 데이터를 내보내시겠습니까?',
      confirm: '내보내기',
      cancel: '취소'
    }
  },

  // 개인정보 설정 화면
  privacyScreen: {
    title: '개인정보 설정 및 정책',
  infoTitle: '개인정보 설정 및 정책',
    messages: {
      deleteAccount: '계정 삭제',
    },
  infoDescription: '여기에서 AI 기능, 데이터 동기화 및 개인정보 관련 설정을 제어하여 개인 정보를 보호할 수 있습니다.',
    privacyProtection: '개인정보 보호',
    privacyDescription: '저희는 귀하의 개인정보를 존중하며 데이터 사용 방법을 완전히 제어할 수 있습니다. 이러한 설정은 앱이 귀하의 개인정보를 어떻게 처리하는지를 결정합니다.',
    aiFeaturesControl: 'AI 기능 제어',
    aiPrivacyControl: 'AI 개인정보 제어',
    aiPrivacySubtitle: '앱에서 AI 기술 사용을 제어하여 데이터 개인정보를 보호',
    enableAiFeatures: 'AI 기능 활성화',
    aiFeatureDescription: '텍스트 인식, 음식 인식, 스마트 추천 등 AI 기능 포함',
    dataUsageSecurity: '데이터 사용 보안',
    dataPrivacyControl: '데이터 개인정보 제어',
    dataPrivacySubtitle: '데이터의 클라우드 저장 및 공유를 제어하여 개인정보 보안 보장',
    cloudDataSharing: '클라우드 데이터 공유',
    cloudSharingDescription: '공유 가계부 생성을 허용하고, 다른 사용자와의 협력을 위해 데이터를 클라우드에 동기화',
    dataUsageExplanation: '데이터 사용 설명',
    dataUsagePoint1: 'AI 처리된 데이터는 해당 기능을 제공하기 위해서만 사용됩니다',
    dataUsagePoint2: '데이터 전송은 암호화 보호를 사용합니다',
    dataUsagePoint3: '귀하의 개인 프라이버시 정보를 저장하지 않습니다',
    dataUsagePoint4: '언제든지 기능을 비활성화할 수 있습니다',
    privacyPolicyAndTerms: '개인정보 처리방침 및 이용약관',
    privacyPolicy: '개인정보 처리방침',
    termsOfService: '서비스 이용약관',
    futurePrivacySettings: '더 많은 개인정보 설정',
    futurePrivacyDescription: '향후 버전에서는 공유 가계부, 데이터 동기화 등 더 많은 개인정보 제어 옵션이 추가될 예정입니다.'
  },

  // 개인정보 처리방침 화면
  privacyPolicyScreen: {
    title: '개인정보 처리방침',
    dataCollection: '데이터 수집',
    dataCollectionContent: '저희는 귀하의 개인정보 보호와 개인정보 보안을 보호할 것을 약속합니다. 이 앱이 수집하는 정보는 더 나은 서비스 경험을 제공하기 위해서만 사용되며, 다른 상업적 목적으로는 사용되지 않습니다.',
    informationUse: '정보 사용',
    informationUseContent: '• 귀하의 개인정보는 앱 기능의 정상적인 운영을 위해서만 사용됩니다\n• 제3자에게 귀하의 개인정보를 판매하거나 공유하지 않습니다\n• 모든 데이터 전송은 암호화됩니다',
    dataSecurity: '데이터 보안',
    dataSecurityContent: '데이터 암호화, 보안 전송 프로토콜 등 업계 표준 보안 조치를 채택하여 귀하의 개인정보를 보호합니다.',
    userRights: '사용자 권리',
    userRightsContent: '귀하는 언제든지 다음 권리를 갖습니다:\n• 저희가 수집한 귀하에 관한 정보를 확인\n• 귀하의 개인정보 수정 또는 삭제 요청\n• 데이터 처리에 대한 동의 철회\n• 언제든지 기능을 비활성화하거나 계정 삭제',
    contactUs: '문의하기',
    contactUsContent: '이 개인정보 처리방침에 대해 질문이 있으시면 문의해 주세요:\n이메일: privacy@cubemeet.com',
    lastUpdated: '최종 업데이트: 2025년 1월 1일'
  },

  // 서비스 이용약관 화면
  termsOfServiceScreen: {
    title: '서비스 이용약관',
    acceptanceOfTerms: '약관 동의',
    acceptanceContent: '이 앱을 사용함으로써 다음 서비스 이용약관을 준수하는 데 동의하는 것으로 간주됩니다. 이러한 약관에 동의하지 않는 경우 이 앱을 사용하지 마세요.',
    serviceDescription: '서비스 설명',
    serviceDescriptionContent: 'CubeMeet은 사용자가 다음을 수행할 수 있도록 돕는 소셜 라이프 앱입니다:\n• 개인 및 공유 가계부 관리\n• 여행, 식사, 카풀 등 그룹 활동 계획\n• 친구들과 삶의 순간 공유\n• AI 스마트 기능을 사용하여 경험 향상',
    userResponsibilities: '사용자 책임',
    userResponsibilitiesContent: '이 앱을 사용할 때 다음에 동의합니다:\n• 정확하고 진실한 정보 제공\n• 법률 및 규정 위반하지 않음\n• 타인의 권리를 침해하지 않음\n• 악의적인 행위나 서비스 남용하지 않음',
    serviceLimitations: '서비스 제한',
    serviceLimitationsContent: '다음 상황에서 서비스를 제한하거나 종료할 권리를 보유합니다:\n• 서비스 이용약관 위반\n• 기술적 유지보수 요구사항\n• 법적 및 규제 요구사항\n• 기타 합리적인 이유',
    disclaimer: '면책 조항',
    disclaimerContent: '이 앱은 "있는 그대로" 서비스를 제공하며 다음에 대해 책임지지 않습니다:\n• 서비스 중단 또는 데이터 손실\n• 제3자 서비스 문제\n• 사용자 간 분쟁\n• 불가항력 요인',
    termsModification: '약관 수정',
    termsModificationContent: '언제든지 이러한 약관을 수정할 권리를 보유합니다. 주요 변경사항은 앱 내 알림을 통해 사용자에게 통지됩니다. 앱의 지속적인 사용은 수정된 약관에 대한 동의를 나타냅니다.',
    contactUs: '문의하기',
    contactUsContent: '이러한 서비스 이용약관에 대해 질문이 있으시면 문의해 주세요:\n이메일: my.cubemeet@gmail.com',
    contactInfo: '연락처 정보',
    contactInfoContent: '질문이나 지원이 필요한 경우 문의해 주세요:\n이메일: support@cubemeet.com',
    lastUpdated: '최종 업데이트: 2025년 1월 1일'
  }
};
